import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type StampHistory = {
  stamp_history_id?: number; // 스탬프 내역 idx
  order_reservation_id?: number; // 오더예약 idx
  shop_information_id?: number; // 쇼/브/매/지 idx
  user_id?: number; // 유저 idx
  stamp_status?: string; // 스탬프 상태
  is_frequency?: string; // 프리퀀시 여부
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] StampHistory
   * --
   */
  getStampHistories: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_STAMP_HISTORY, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] StampHistory
   * --
   */
  getStampHistory: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_STAMP_HISTORY, {
        stamp_history_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] StampHistory
   * --
   */
  createStampHistory: async (body: StampHistory) => {
    try {
      const res = await $http.post(APIConstant.CREATE_STAMP_HISTORY, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] StampHistory
   * --
   */
  updateStampHistory: async (body: StampHistory) => {
    try {
      const { stamp_history_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_STAMP_HISTORY, {
        stamp_history_id: stamp_history_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] StampHistory
   * --
   */
  deleteStampHistory: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_STAMP_HISTORY, {
        stamp_history_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] RewardStampHistory
   * --
   */
  rewardStampHistory: async (body: StampHistory) => {
    try {
      const res = await $http.post(APIConstant.REWARD_STAMP_HISTORY, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] bulkUpdateStampHistory
   * --
   */
  bulkUpdateStampHistory: async (body: StampHistory[]) => {
    try {
      const res = await $http.bulk(
        APIConstant.BULK_UPDATE_STAMP_HISTORY,
        body,
        'PUT'
      );

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
